import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=51ab606a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ab606a')) {
      api.createRecord('51ab606a', component.options)
    } else {
      api.reload('51ab606a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=51ab606a&", function () {
      api.rerender('51ab606a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Kscws8Wm9NqN/JS/comp/ImgFallback.vue"
export default component.exports